// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"3278":"c97a360506d6ebb6afd2","3564":"1f97cb34040f17de0c20","7471":"428f6893ae52e7aca00b","8790":"9fd8f6ad2d5d29ec25ad"}[chunkId] + "";
};